export class AlbumController {
    constructor($scope, $rootScope, $route, UserService) {
      $scope.userData = {};
      $scope.successGetUserProfile = true;
      this.scope = $scope;
      this.rootScope = $rootScope;
      this.route = $route;
      this.userId = this.route.current.params.id;
      this.UserService = UserService;
      this.init();
  }

  init() {
    this.scope.isLoadedPage = false;
    //Get current User Profile
    this.UserService.getCurrentUser()
    .then((response) => { let currentUserProfile = response.data;
      this.rootScope.currentUserProfile = currentUserProfile.data;
        //get this user profile
        this.UserService.getUserProfile(this.userId)
          .then((response) => { let user = response.data;
            this.scope.isLoadedPage = true;
            this.scope.userData = user.data;
          })
          .catch((response) => { let err = response.data;
            this.scope.isLoadedPage = true;
            this.scope.successGetUserProfile = false;
            console.error(err);
          });
      })
      .catch((response) => { let err = response.data;
        this.scope.isLoadedPage = true;
        console.error(err);
      });
  }
}
